// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup-error{width:100%;max-width:400px;top:50%;right:50%;transform:translate(50%,-50%);border-radius:10px}", ""]);
// Exports
module.exports = exports;
